import { createSlice } from '@reduxjs/toolkit';

// chatAvailable starts null rather than true: until fetchAssistant has answered
// we have not confirmed anything, and a default of `true` would let chat
// surfaces render as working during the initial load.
const assistantSlice = createSlice({
  name: 'assistant',
  initialState: { chatAvailable: null },
  reducers: {
    createAssistant: (state, action) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.chatAvailable = true;
      state.degradedReason = undefined;
    },
    setAssistantUnavailable: (state, { payload }) => {
      // A failed request does not mean the assistant ceased to exist. Clearing
      // its identity here made every send path unable to recover in this session.
      state.chatAvailable = false;
      state.degradedReason = payload?.reason || 'assistant_unavailable';
    },
    clearAssistantUnavailable: (state) => {
      state.chatAvailable = true;
      state.degradedReason = undefined;
    },
  }
})

export const { createAssistant, setAssistantUnavailable, clearAssistantUnavailable } = assistantSlice.actions

export default assistantSlice.reducer;
